import { Colors, Text } from '@amelio/ui-library';

export interface RevieweeInformationProps {
    revieweeFullName: string;
    revieweeJobTitle: string;
}

export const RevieweeInformation = ({
    revieweeFullName,
    revieweeJobTitle,
}: RevieweeInformationProps) => (
    <div className={'min-w-0 flex-1'}>
        <Text
            size={'small'}
            weight={'medium'}
            className={'block truncate text-sm'}
        >
            {revieweeFullName}
        </Text>

        <Text
            size={'small'}
            color={Colors.BASE_500}
            className={'block truncate text-xs'}
        >
            {revieweeJobTitle}
        </Text>
    </div>
);
